import { ItemAttributeRateKeyBase } from './base/item-attribute-rate-key-base';

export class ItemAttributeRateKey extends ItemAttributeRateKeyBase { }